export const VALID_ORG_NAMES = ['GCS', 'LCS'] as const;
export const ORG_NAME_PATTERN = new RegExp(`^(${VALID_ORG_NAMES.join('|')})$`);
